// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Media Queries */
@media only screen and (min-width: 280px) and (max-width: 482px), only screen and (min-width: 482px) and (max-width: 599px), only screen and (min-width: 482px) and (max-width: 666px) {
  #SolutionsSectionOne {
    padding: 100px 30px 30px;
    display: block !important;
  }
  #SolutionsSectionOne .SolutionsSectionOne-left {
    width: 100%;
    display: block;
    padding: 0;
  }
  #SolutionsSectionOne .SolutionsSectionOne-left #SolutionsSectionOne-left-head {
    width: 100%;
    font-size: 28px;
    margin: 0 10px 20px 0;
    line-height: 1.3em;
  }
  #SolutionsSectionOne .SolutionsSectionOne-left #SolutionsSectionOne-left-middle {
    width: 100%;
  }
  #SolutionsSectionOne .SolutionsSectionOne-left #SolutionsSectionOne-left-middle #SolutionsSectionOne-left-middle-left {
    width: 100%;
    font-size: 14px;
    text-align: justify;
    line-height: 1.8;
    margin-bottom: 1em;
    margin-left: 0;
  }
  #SolutionsSectionOne .SolutionsSectionOne-right {
    width: 100%;
  }
  #SolutionsSectionOne .SolutionsSectionOne-right #SolutionsSectionOne-image-bg {
    margin-top: 20px;
    width: 100%;
  }
  .sectionTwoSolutions {
    padding-top: 0;
    height: auto !important;
  }
  .sectionTwoSolutions .SolutionsSection-Discover {
    display: block;
  }
  .sectionTwoSolutions .SolutionsSection-Discover .SolutionsSections-discover-industry {
    padding: 30px;
    width: 100%;
    height: auto;
  }
  .sectionTwoSolutions .SolutionsSection-Discover .SolutionsSections-discover-industry .subHeading {
    font-size: 16px;
  }
  .sectionTwoSolutions .SolutionsSection-Discover .SolutionsSections-discover-industry .heading {
    font-size: 28px;
    line-height: 1;
    margin: 20px 0;
  }
  .sectionTwoSolutions .SolutionsSection-Discover .SolutionsSections-discover-industry .discover-link {
    font-size: 14px;
  }
  .sectionTwoSolutions .SolutionsSection-Discover .SolutionsSections-discover-key-areas {
    padding: 30px;
    width: 100%;
    height: auto;
  }
  .sectionTwoSolutions .SolutionsSection-Discover .SolutionsSections-discover-key-areas .subHeading {
    font-size: 16px;
  }
  .sectionTwoSolutions .SolutionsSection-Discover .SolutionsSections-discover-key-areas .heading {
    font-size: 28px;
    line-height: 1;
    margin: 20px 0;
  }
  .sectionTwoSolutions .SolutionsSection-Discover .SolutionsSections-discover-key-areas .discover-link {
    font-size: 14px;
  }
  .sectionThree-Solutions {
    margin-top: 0;
    padding: 30px;
  }
  .sectionThree-Solutions #SolutionsSectionThree-content {
    margin-top: 5%;
    width: 100%;
  }
  .sectionThree-Solutions #SolutionsSectionThree-content #SolutionsSectionThree-head {
    font-size: 24px;
    margin-top: 0;
    line-height: 1.3;
  }
  .sectionThree-Solutions #SolutionsSectionThree-content #SolutionsSectionThree-subhead {
    font-size: 14px;
    line-height: 1.8 !important;
    margin-top: 0;
  }
  .sectionThree-Solutions #SolutionsSectionThree-content #SolutionsSectionThree-card-section {
    flex-direction: column-reverse;
    padding-left: 0;
  }
  .sectionThree-Solutions #SolutionsSectionThree-content #SolutionsSectionThree-card-section #SolutionsSectionThree-delivery-approach-image-1 {
    width: 100%;
    margin-right: 0;
    margin-top: -10px;
  }
  .sectionThree-Solutions #SolutionsSectionThree-content #SolutionsSectionThree-card-section #SolutionsSectionThree-delivery-approach-image-2 {
    margin-left: 0;
    width: 85%;
    margin-top: -25px;
  }
  .sectionThree-Solutions #SolutionsSectionThree-content #SolutionsSectionThree-left-middle-bottom {
    font-size: 14px;
    line-height: 1.8 !important;
    margin-top: 10px;
    text-align: center;
    padding: 20px;
  }
}
@media only screen and (min-width: 667px) and (max-width: 1023px) {
  #SolutionsSectionOne {
    display: block;
    padding: 100px 30px 30px;
    background-image: none;
  }
  #SolutionsSectionOne .SolutionsSectionOne-left {
    width: 100%;
    padding: 0;
  }
  #SolutionsSectionOne .SolutionsSectionOne-left #SolutionsSectionOne-left-head {
    margin-top: 0;
    width: 100%;
    font-size: 28px;
    margin-bottom: 20px;
    font-weight: bold;
  }
  #SolutionsSectionOne .SolutionsSectionOne-left #SolutionsSectionOne-left-middle {
    width: 100%;
  }
  #SolutionsSectionOne .SolutionsSectionOne-left #SolutionsSectionOne-left-middle #SolutionsSectionOne-left-middle-left {
    margin-left: 0;
    margin-right: 10px;
    text-align: justify;
    font-size: 16px;
    line-height: 1.8;
  }
  #SolutionsSectionOne .SolutionsSectionOne-right {
    width: 100%;
  }
  #SolutionsSectionOne .SolutionsSectionOne-right #SolutionsSectionOne-image-bg {
    margin-top: 50px;
    margin-right: 20px;
  }
  .sectionTwoSolutions {
    padding-top: 4vh;
    padding-bottom: 100px;
    height: auto !important;
  }
  .sectionTwoSolutions .SolutionsSections-discover-industry,
  .sectionTwoSolutions .SolutionsSections-discover-key-areas {
    height: auto !important;
    padding: 30px !important;
  }
  .sectionTwoSolutions .SolutionsSections-discover-industry .subHeading,
  .sectionTwoSolutions .SolutionsSections-discover-key-areas .subHeading {
    font-size: 18px !important;
  }
  .sectionTwoSolutions .SolutionsSections-discover-industry .heading,
  .sectionTwoSolutions .SolutionsSections-discover-key-areas .heading {
    font-size: 34px !important;
    line-height: 1 !important;
    margin: 30px 0 !important;
  }
  .sectionTwoSolutions .SolutionsSections-discover-industry .discover-link,
  .sectionTwoSolutions .SolutionsSections-discover-key-areas .discover-link {
    font-size: 15px !important;
  }
  #SolutionsSectionThree {
    margin-top: 0;
    padding: 30px;
  }
  #SolutionsSectionThree #SolutionsSectionThree-content #SolutionsSectionThree-head {
    font-size: 28px;
  }
  #SolutionsSectionThree #SolutionsSectionThree-content #SolutionsSectionThree-subhead {
    font-size: 16px;
    line-height: 1.8 !important;
  }
  #SolutionsSectionThree #SolutionsSectionThree-content #SolutionsSectionThree-card-section {
    flex-direction: column-reverse;
    padding: 0;
    margin-top: 0;
  }
  #SolutionsSectionThree #SolutionsSectionThree-content #SolutionsSectionThree-card-section #SolutionsSectionThree-delivery-approach-image-1 {
    margin-right: 0;
    width: 70vw;
  }
  #SolutionsSectionThree #SolutionsSectionThree-content #SolutionsSectionThree-card-section #SolutionsSectionThree-delivery-approach-image-2 {
    margin-left: 0;
    width: 55vw;
  }
  #SolutionsSectionThree #SolutionsSectionThree-content #SolutionsSectionThree-left-middle-bottom {
    text-align: center;
  }
}
@media only screen and (min-width: 900px) and (max-width: 1023px) {
  #SolutionsSectionThree-card-section {
    flex-direction: row !important;
    margin-top: 6% !important;
  }
  #SolutionsSectionThree-card-section #SolutionsSectionThree-delivery-approach-image-1 {
    width: 60% !important;
    margin-right: -50px !important;
  }
  #SolutionsSectionThree-card-section #SolutionsSectionThree-delivery-approach-image-2 {
    width: 60% !important;
  }
  #SolutionsSectionThree-left-middle-bottom {
    padding: 40px !important;
  }
}
@media only screen and (min-width: 1024px) and (max-width: 1280px) {
  #SolutionsSectionOne {
    padding: 120px 60px 100px;
    background-position: -80px 185px;
  }
  #SolutionsSectionOne .SolutionsSectionOne-left {
    justify-content: flex-start;
    padding-left: 0;
    flex: 1 1;
  }
  #SolutionsSectionOne .SolutionsSectionOne-left #SolutionsSectionOne-left-head {
    width: 100%;
    margin-top: 0;
    font-size: 28px;
    font-weight: bold;
    line-height: 1.33em;
  }
  #SolutionsSectionOne .SolutionsSectionOne-left #SolutionsSectionOne-left-middle {
    width: 100%;
  }
  #SolutionsSectionOne .SolutionsSectionOne-left #SolutionsSectionOne-left-middle #SolutionsSectionOne-left-middle-left {
    margin-left: 0;
    text-align: justify;
    font-size: 16px;
    line-height: 1.8;
  }
  #SolutionsSectionOne .SolutionsSectionOne-right {
    flex: 1 1;
  }
  #SolutionsSectionOne .SolutionsSectionOne-right #SolutionsSectionOne-image-bg {
    margin-top: 40px;
    margin-right: -30px;
    width: 90%;
  }
  .sectionTwoSolutions {
    padding-top: 0;
    height: auto !important;
  }
  .sectionTwoSolutions .SolutionsSections-discover-industry,
  .sectionTwoSolutions .SolutionsSections-discover-key-areas {
    padding: 50px !important;
    height: auto !important;
  }
  .sectionTwoSolutions .SolutionsSections-discover-industry .heading,
  .sectionTwoSolutions .SolutionsSections-discover-key-areas .heading {
    font-size: 40px !important;
  }
  .sectionThree-Solutions {
    margin-top: 0;
  }
  .sectionThree-Solutions #SolutionsSectionThree-head {
    font-size: 28px;
  }
  .sectionThree-Solutions #SolutionsSectionThree-card-section {
    padding-right: 20px;
    margin-top: 6%;
  }
  .sectionThree-Solutions #SolutionsSectionThree-card-section #SolutionsSectionThree-delivery-approach-image-1 {
    width: 60%;
    margin-right: -30px;
  }
  .sectionThree-Solutions #SolutionsSectionThree-card-section #SolutionsSectionThree-delivery-approach-image-2 {
    width: 60%;
  }
  .sectionThree-Solutions #SolutionsSectionThree-left-middle-bottom {
    padding: 40px 40px 45px !important;
  }
}`, "",{"version":3,"sources":["webpack://./src/media-queries.scss","webpack://./src/components/Solutions/solution.scss"],"names":[],"mappings":"AAEA,kBAAA;AAmCI;ECjCF;IACC,wBAAA;IACA,yBAAA;EADD;EAEC;IACC,WAAA;IACA,cAAA;IACA,UAAA;EAAF;EACE;IACC,WAAA;IACA,eAAA;IACG,qBAAA;IACA,kBAAA;EACN;EACE;IACC,WAAA;EACH;EAAG;IACC,WAAA;IACG,eAAA;IACA,mBAAA;IACA,gBAAA;IACA,kBAAA;IACA,cAAA;EAEP;EAEC;IACC,WAAA;EAAF;EACE;IACC,gBAAA;IACA,WAAA;EACH;EAIA;IACC,cAAA;IACA,uBAAA;EAFD;EAGC;IACC,cAAA;EADF;EAEE;IACC,aAAA;IACG,WAAA;IACA,YAAA;EAAN;EACG;IACC,eAAA;EACJ;EACG;IACC,eAAA;IACA,cAAA;IACA,cAAA;EACJ;EACG;IACC,eAAA;EACJ;EAEE;IACC,aAAA;IACG,WAAA;IACA,YAAA;EAAN;EACK;IACD,eAAA;EACJ;EACG;IACC,eAAA;IACA,cAAA;IACA,cAAA;EACJ;EACG;IACC,eAAA;EACJ;EAKA;IACC,aAAA;IACA,aAAA;EAHD;EAIC;IACC,cAAA;IACA,WAAA;EAFF;EAGE;IACC,eAAA;IACA,aAAA;IACA,gBAAA;EADH;EAGE;IACC,eAAA;IACA,2BAAA;IACA,aAAA;EADH;EAGE;IACC,8BAAA;IACA,eAAA;EADH;EAEG;IACC,WAAA;IACA,eAAA;IACA,iBAAA;EAAJ;EAEG;IACC,cAAA;IACA,UAAA;IACA,iBAAA;EAAJ;EAGE;IACC,eAAA;IACA,2BAAA;IACA,gBAAA;IACA,kBAAA;IACA,aAAA;EADH;AACF;AD5EI;ECmFF;IACC,cAAA;IACA,wBAAA;IACA,sBAAA;EAJD;EAKC;IACC,WAAA;IACA,UAAA;EAHF;EAIE;IACC,aAAA;IACA,WAAA;IACA,eAAA;IACA,mBAAA;IACA,iBAAA;EAFH;EAIE;IACC,WAAA;EAFH;EAGG;IACC,cAAA;IACA,kBAAA;IACA,mBAAA;IACA,eAAA;IACA,gBAAA;EADJ;EAKC;IACC,WAAA;EAHF;EAIE;IACI,gBAAA;IACA,kBAAA;EAFN;EAOA;IACC,gBAAA;IACA,qBAAA;IACA,uBAAA;EALD;EAMC;;IAEC,uBAAA;IACA,wBAAA;EAJF;EAKE;;IACC,0BAAA;EAFH;EAIE;;IACC,0BAAA;IACA,yBAAA;IACA,yBAAA;EADH;EAGE;;IACC,0BAAA;EAAH;EAKA;IACC,aAAA;IACA,aAAA;EAHD;EAKE;IACC,eAAA;EAHH;EAKE;IACC,eAAA;IACA,2BAAA;EAHH;EAKE;IACC,8BAAA;IACA,UAAA;IACA,aAAA;EAHH;EAIG;IACC,eAAA;IACA,WAAA;EAFJ;EAIG;IACC,cAAA;IACA,WAAA;EAFJ;EAKE;IACC,kBAAA;EAHH;AACF;ADlKI;EC2KF;IACC,8BAAA;IACA,yBAAA;EAND;EAOC;IACC,qBAAA;IACA,8BAAA;EALF;EAOC;IACC,qBAAA;EALF;EAQA;IACC,wBAAA;EAND;AACF;ADlLI;EC4LF;IACC,yBAAA;IACA,gCAAA;EAPD;EAQC;IACC,2BAAA;IACA,eAAA;IACA,SAAA;EANF;EAOE;IACC,WAAA;IACA,aAAA;IACA,eAAA;IACA,iBAAA;IACA,mBAAA;EALH;EAOE;IACC,WAAA;EALH;EAMG;IACC,cAAA;IACA,mBAAA;IACA,eAAA;IACA,gBAAA;EAJJ;EAQC;IACC,SAAA;EANF;EAOE;IACI,gBAAA;IACA,mBAAA;IACA,UAAA;EALN;EAUA;IACC,cAAA;IACA,uBAAA;EARD;EASC;;IAEC,wBAAA;IACA,uBAAA;EAPF;EAQE;;IACC,0BAAA;EALH;EAUA;IACC,aAAA;EARD;EASC;IACC,eAAA;EAPF;EASC;IACC,mBAAA;IACA,cAAA;EAPF;EAQE;IACC,UAAA;IACA,mBAAA;EANH;EAQE;IACC,UAAA;EANH;EASC;IACC,kCAAA;EAPF;AACF","sourcesContent":["$size__site_content_width : 1024px;\n\n/* Media Queries */ \n\n$media_queries : (\n    'mobile360'         : unquote(\"only screen and (min-width: 280px) and (max-width: 400px)\"),\n    'xs'                : unquote(\"only screen and (min-width: 280px) and (max-width: 482px)\"),\n    'miniMobile'        : unquote(\"only screen and (min-width: 280px) and (max-width: 450px)\"),\n    'mediumMobile'      : unquote(\"only screen and (min-width: 450px) and (max-width: 482px)\"),\n    'eReaders'          : unquote(\"only screen and (min-width: 482px) and (max-width: 599px)\"),\n    'mobile'            : unquote(\"only screen and (min-width: 482px) and (max-width: 666px)\"),\n    'customMobile'      : unquote(\"only screen and (min-width: 600px) and (max-width: 900px)\"),\n    'miniTab'           : unquote(\"only screen and (min-width: 667px) and (max-width: 900px)\"),\n    'tablet'            : unquote(\"only screen and (min-width: 667px) and (max-width: 1023px)\"),\n    'customTablet'      : unquote(\"only screen and (min-width: 900px) and (max-width: 1023px)\"),\n    'wideTablet'        : unquote(\"only screen and (min-width: 1024px) and (max-width: 1280px)\"),\n    'miniDesktop'       : unquote(\"only screen and (min-width: 1281px) and (max-width: 1482px)\"),\n    'desktop'           : unquote(\"only screen and (min-width: 1025px)\"),\n    'wideScreens'       : unquote(\"only screen and (min-width: 1339px)\"),\n    'hdScreen'          : unquote(\"only screen and (min-width: 1800px)\"),\n    'retina2'           : unquote(\"only screen and (-webkit-min-device-pixel-ratio: 2) and (min-resolution: 192dpi)\"),\n    'retina3'           : unquote(\"only screen and (-webkit-min-device-pixel-ratio: 3) and (min-resolution: 288dpi)\"),\n    'landscape'         : unquote(\"screen and (orientation:landscape)\"),    \n    'portrait'          : unquote(\"screen and (orientation:portrait)\")\n);\n\n@mixin devices($breakpoints) {\n    $conditions : ();\n    @each $breakpoint in $breakpoints {\n        // If the key exists in the map\n        $conditions: append(\n            $conditions,\n            #{inspect(map-get($media_queries, $breakpoint))},\n            comma\n        );\n    }\n\n    @media #{$conditions} {\n        @content;\n    }\n\n}\n","@import '../../media-queries.scss';\n\n// responsive\n@include devices(xs eReaders mobile) {\n\t\t#SolutionsSectionOne {\n\t\t\tpadding: 100px 30px 30px;\n\t\t\tdisplay: block !important;\n\t\t\t.SolutionsSectionOne-left {\n\t\t\t\twidth: 100%;\n\t\t\t\tdisplay: block;\n\t\t\t\tpadding: 0;\n\t\t\t\t#SolutionsSectionOne-left-head {\n\t\t\t\t\twidth: 100%;\n\t\t\t\t\tfont-size: 28px;\n\t\t\t\t    margin: 0 10px 20px 0;\n\t\t\t\t    line-height: 1.3em\n\t\t\t\t}\n\t\t\t\t#SolutionsSectionOne-left-middle {\n\t\t\t\t\twidth: 100%;\n\t\t\t\t\t#SolutionsSectionOne-left-middle-left {\n\t\t\t\t\t\twidth: 100%;\n\t\t\t\t\t    font-size: 14px;\n\t\t\t\t\t    text-align: justify;\n\t\t\t\t\t    line-height: 1.8;\n\t\t\t\t\t    margin-bottom: 1em;\n\t\t\t\t\t    margin-left: 0;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t\t.SolutionsSectionOne-right {\n\t\t\t\twidth: 100%;\n\t\t\t\t#SolutionsSectionOne-image-bg {\n\t\t\t\t\tmargin-top: 20px;\n\t\t\t\t\twidth: 100%;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\n\t\t.sectionTwoSolutions {\n\t\t\tpadding-top: 0;\n\t\t\theight: auto !important;\n\t\t\t.SolutionsSection-Discover {\n\t\t\t\tdisplay: block;\n\t\t\t\t.SolutionsSections-discover-industry {\n\t\t\t\t\tpadding: 30px;\n\t\t\t\t    width: 100%;\n\t\t\t\t    height: auto;\n\t\t\t\t\t.subHeading {\n\t\t\t\t\t\tfont-size: 16px;\n\t\t\t\t\t}\n\t\t\t\t\t.heading {\n\t\t\t\t\t\tfont-size: 28px;\n\t\t\t\t\t\tline-height: 1;\n\t\t\t\t\t\tmargin: 20px 0;\n\t\t\t\t\t}\n\t\t\t\t\t.discover-link {\n\t\t\t\t\t\tfont-size: 14px;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t\t.SolutionsSections-discover-key-areas {\n\t\t\t\t\tpadding: 30px;\n\t\t\t\t    width: 100%;\n\t\t\t\t    height: auto;\n\t\t\t\t   .subHeading {\n\t\t\t\t\t\tfont-size: 16px;\n\t\t\t\t\t}\n\t\t\t\t\t.heading {\n\t\t\t\t\t\tfont-size: 28px;\n\t\t\t\t\t\tline-height: 1;\n\t\t\t\t\t\tmargin: 20px 0;\n\t\t\t\t\t}\n\t\t\t\t\t.discover-link {\n\t\t\t\t\t\tfont-size: 14px;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\n\t\t.sectionThree-Solutions {\n\t\t\tmargin-top: 0;\n\t\t\tpadding: 30px;\n\t\t\t#SolutionsSectionThree-content {\n\t\t\t\tmargin-top: 5%;\n\t\t\t\twidth: 100%;\n\t\t\t\t#SolutionsSectionThree-head {\n\t\t\t\t\tfont-size: 24px;\n\t\t\t\t\tmargin-top: 0;\n\t\t\t\t\tline-height: 1.3;\n\t\t\t\t}\n\t\t\t\t#SolutionsSectionThree-subhead {\n\t\t\t\t\tfont-size: 14px;\n\t\t\t\t\tline-height: 1.8 !important;\n\t\t\t\t\tmargin-top: 0;\n\t\t\t\t}\n\t\t\t\t#SolutionsSectionThree-card-section {\n\t\t\t\t\tflex-direction: column-reverse;\n\t\t\t\t\tpadding-left: 0;\n\t\t\t\t\t#SolutionsSectionThree-delivery-approach-image-1 {\n\t\t\t\t\t\twidth: 100%;\n\t\t\t\t\t\tmargin-right: 0;\n\t\t\t\t\t\tmargin-top: -10px;\n\t\t\t\t\t}\n\t\t\t\t\t#SolutionsSectionThree-delivery-approach-image-2 {\n\t\t\t\t\t\tmargin-left: 0;\n\t\t\t\t\t\twidth: 85%;\n\t\t\t\t\t\tmargin-top: -25px;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t\t#SolutionsSectionThree-left-middle-bottom {\n\t\t\t\t\tfont-size: 14px;\n\t\t\t\t\tline-height: 1.8 !important;\n\t\t\t\t\tmargin-top: 10px;\n\t\t\t\t\ttext-align: center;\n\t\t\t\t\tpadding: 20px;\n\t\t\t\t}\n\t\t\t}\n\t\t}\t\n\t}\n\n\t@include devices(tablet) {\n\t\t#SolutionsSectionOne {\n\t\t\tdisplay: block;\n\t\t\tpadding: 100px 30px 30px;\n\t\t\tbackground-image: none;\n\t\t\t.SolutionsSectionOne-left {\n\t\t\t\twidth: 100%;\n\t\t\t\tpadding: 0;\n\t\t\t\t#SolutionsSectionOne-left-head {\n\t\t\t\t\tmargin-top: 0;\n\t\t\t\t\twidth: 100%;\n\t\t\t\t\tfont-size: 28px;\n\t\t\t\t\tmargin-bottom: 20px;\n\t\t\t\t\tfont-weight: bold;\n\t\t\t\t}\n\t\t\t\t#SolutionsSectionOne-left-middle {\n\t\t\t\t\twidth: 100%;\n\t\t\t\t\t#SolutionsSectionOne-left-middle-left {\n\t\t\t\t\t\tmargin-left: 0;\n\t\t\t\t\t\tmargin-right: 10px;\n\t\t\t\t\t\ttext-align: justify;\n\t\t\t\t\t\tfont-size: 16px;\n\t\t\t\t\t\tline-height: 1.8;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t\t.SolutionsSectionOne-right {\n\t\t\t\twidth: 100%;\n\t\t\t\t#SolutionsSectionOne-image-bg {\n\t\t\t\t    margin-top: 50px;\n\t    \t\t\tmargin-right: 20px;\n\t\t\t\t}\n\t\t\t}\n\t\t}\t\n\n\t\t.sectionTwoSolutions {\n\t\t\tpadding-top: 4vh;\n\t\t\tpadding-bottom: 100px;\n\t\t\theight: auto !important;\n\t\t\t.SolutionsSections-discover-industry,\n\t\t\t.SolutionsSections-discover-key-areas {\n\t\t\t\theight: auto !important;\n\t\t\t\tpadding: 30px !important;\n\t\t\t\t.subHeading {\n\t\t\t\t\tfont-size: 18px !important;\n\t\t\t\t}\n\t\t\t\t.heading {\n\t\t\t\t\tfont-size: 34px !important;\n\t\t\t\t\tline-height: 1 !important;\n\t\t\t\t\tmargin: 30px 0 !important;\n\t\t\t\t}\n\t\t\t\t.discover-link {\n\t\t\t\t\tfont-size: 15px !important;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\n\t\t#SolutionsSectionThree {\n\t\t\tmargin-top: 0;\n\t\t\tpadding: 30px;\n\t\t\t#SolutionsSectionThree-content {\n\t\t\t\t#SolutionsSectionThree-head {\n\t\t\t\t\tfont-size: 28px;\n\t\t\t\t}\n\t\t\t\t#SolutionsSectionThree-subhead {\n\t\t\t\t\tfont-size: 16px;\n\t\t\t\t\tline-height: 1.8 !important;\n\t\t\t\t}\n\t\t\t\t#SolutionsSectionThree-card-section {\n\t\t\t\t\tflex-direction: column-reverse;\n\t\t\t\t\tpadding: 0;\n\t\t\t\t\tmargin-top: 0;\n\t\t\t\t\t#SolutionsSectionThree-delivery-approach-image-1 {\n\t\t\t\t\t\tmargin-right: 0;\n\t\t\t\t\t\twidth: 70vw;\n\t\t\t\t\t}\n\t\t\t\t\t#SolutionsSectionThree-delivery-approach-image-2 {\n\t\t\t\t\t\tmargin-left: 0;\n\t\t\t\t\t\twidth: 55vw;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t\t#SolutionsSectionThree-left-middle-bottom {\n\t\t\t\t\ttext-align: center;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n\n\t@include devices(customTablet) {\n\t\t#SolutionsSectionThree-card-section {\n\t\t\tflex-direction: row !important;\n\t\t\tmargin-top: 6% !important;\n\t\t\t#SolutionsSectionThree-delivery-approach-image-1 {\n\t\t\t\twidth: 60% !important;\n\t\t\t\tmargin-right: -50px !important;\n\t\t\t}\n\t\t\t#SolutionsSectionThree-delivery-approach-image-2 {\n\t\t\t\twidth: 60% !important;\n\t\t\t}\n\t\t}\n\t\t#SolutionsSectionThree-left-middle-bottom {\n\t\t\tpadding: 40px !important;\n\t\t}\n\t}\n\n\t@include devices(wideTablet) {\n\t\t#SolutionsSectionOne {\n\t\t\tpadding: 120px 60px 100px;\n\t\t\tbackground-position: -80px 185px;\n\t\t\t.SolutionsSectionOne-left {\n\t\t\t\tjustify-content: flex-start;\n\t\t\t\tpadding-left: 0;\n\t\t\t\tflex: 1 1;\n\t\t\t\t#SolutionsSectionOne-left-head {\n\t\t\t\t\twidth: 100%;\n\t\t\t\t\tmargin-top: 0;\n\t\t\t\t\tfont-size: 28px;\n\t\t\t\t\tfont-weight: bold;\n\t\t\t\t\tline-height: 1.33em;\n\t\t\t\t}\n\t\t\t\t#SolutionsSectionOne-left-middle {\n\t\t\t\t\twidth: 100%;\n\t\t\t\t\t#SolutionsSectionOne-left-middle-left {\n\t\t\t\t\t\tmargin-left: 0;\n\t\t\t\t\t\ttext-align: justify;\n\t\t\t\t\t\tfont-size: 16px;\n\t\t\t\t\t\tline-height: 1.8;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t\t.SolutionsSectionOne-right {\n\t\t\t\tflex: 1 1;\n\t\t\t\t#SolutionsSectionOne-image-bg {\n\t\t\t\t    margin-top: 40px;\n\t\t\t\t    margin-right: -30px;\n\t\t\t\t    width: 90%;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\n\t\t.sectionTwoSolutions {\n\t\t\tpadding-top: 0;\n\t\t\theight: auto !important;\n\t\t\t.SolutionsSections-discover-industry,\n\t\t\t.SolutionsSections-discover-key-areas {\n\t\t\t\tpadding: 50px !important;\n\t\t\t\theight: auto !important;\n\t\t\t\t.heading {\n\t\t\t\t\tfont-size: 40px !important;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\n\t\t.sectionThree-Solutions {\n\t\t\tmargin-top: 0;\n\t\t\t#SolutionsSectionThree-head {\n\t\t\t\tfont-size: 28px;\n\t\t\t}\n\t\t\t#SolutionsSectionThree-card-section {\n\t\t\t\tpadding-right: 20px;\n\t\t\t\tmargin-top: 6%;\n\t\t\t\t#SolutionsSectionThree-delivery-approach-image-1 {\n\t\t\t\t\twidth: 60%;\n\t\t\t\t\tmargin-right: -30px;\n\t\t\t\t}\n\t\t\t\t#SolutionsSectionThree-delivery-approach-image-2 {\n\t\t\t\t\twidth: 60%;\n\t\t\t\t}\n\t\t\t}\n\t\t\t#SolutionsSectionThree-left-middle-bottom {\n\t\t\t\tpadding: 40px 40px 45px !important;\n\t\t\t}\n\t\t}\n\t}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
